import Styles from '../../WizardsDrawerV4.module.scss'
import { LevelProps } from '../../Types'
import { CardSection } from '../CardSection'
import { LEVEL_CARDS, RECENT_WIZARDS_LEVEL_1_MAX_CARDS } from '../../Constants'
import { useForYouItems } from '../../hooks/useForYouItems'

export const Level1 = (props: LevelProps) => {
  const { handleLevel } = props
  const { L1 } = LEVEL_CARDS

  let { type: forYouType, cards: forYouCards } = useForYouItems()
  let forYouSeeAll = undefined

  if (forYouType === 'recently_used') {
    if (forYouCards.length > RECENT_WIZARDS_LEVEL_1_MAX_CARDS) {
      forYouSeeAll = handleLevel('recently_used')
    }
    forYouCards = forYouCards.slice(0, RECENT_WIZARDS_LEVEL_1_MAX_CARDS)
  }

  return (
    <>
      <h1>Create New</h1>

      <CardSection
        {...props}
        title={forYouType === 'recently_used' ? 'Recently Used' : 'For You'}
        className={Styles.forYouSection}
        items={forYouCards}
        handleSeeAll={forYouSeeAll}
      />
      <CardSection {...props} title="Social Media" handleSeeAll={handleLevel('social_media')} items={L1.SOCIAL_MEDIA} />
      <CardSection {...props} title="Marketplace" items={L1.MARKETPLACE} />
      <CardSection {...props} title="Video" handleSeeAll={handleLevel('video')} items={L1.VIDEO} />
      <CardSection
        {...props}
        className={Styles.blogPostBuilder}
        title="Blog/SEO"
        handleSeeAll={handleLevel('blogs_seo')}
        items={L1.BLOG_SEO}
      />

      <CardSection
        {...props}
        title="Brainstorm Ideas"
        handleSeeAll={handleLevel('brainstorm_ideas')}
        items={L1.BRAINSTORM_IDEAS}
      />

      <CardSection {...props} title="Start Blank" items={L1.START_BLANK} />
      <CardSection {...props} title="Advanced Tools" items={L1.ADVANCED_TOOLS} />
      <CardSection {...props} title="Ad Copy" items={L1.AD_COPY} />
      <CardSection {...props} title="Emails" items={L1.EMAILS} />
      <CardSection {...props} title="Other" items={L1.OTHER} />
    </>
  )
}
